import { render, staticRenderFns } from "./SCFSPrintModel.vue?vue&type=template&id=649012e4&scoped=true"
import script from "./SCFSPrintModel.vue?vue&type=script&lang=js"
export * from "./SCFSPrintModel.vue?vue&type=script&lang=js"
import style0 from "./SCFSPrintModel.vue?vue&type=style&index=0&id=649012e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649012e4",
  null
  
)

export default component.exports